if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        const featuredMediaId = opener.getAttribute("data-featured-media-id");
        // Зберігаємо зображення з картки для подальшого використання
        const cardImage = opener
          .closest(".card-wrapper")
          ?.querySelector(".card__media img");
        this.cardImageSrc = cardImage?.src || null;
        this.cardImageSrcset = cardImage?.srcset || null;
        console.log(
          "[QuickAdd] Opening modal, featuredMediaId:",
          featuredMediaId,
          "cardImageSrc:",
          this.cardImageSrc
        );

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector("product-info");
            console.log(
              "[QuickAdd] Product element found:",
              !!this.productElement
            );
            console.log(
              "[QuickAdd] Original sectionId:",
              this.productElement?.dataset?.section
            );

            this.preventDuplicatedIDs();
            this.removeDOMElements();

            // Зберігаємо sectionId перед вставкою
            this.quickaddSectionId = this.productElement.dataset.section;
            console.log(
              "[QuickAdd] Saved quickaddSectionId:",
              this.quickaddSectionId
            );

            // Вставляємо innerHTML від productElement
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            // Після вставки знаходимо product-info в modalContent і встановлюємо атрибути
            const insertedProductInfo =
              this.modalContent.querySelector("product-info");
            if (insertedProductInfo) {
              insertedProductInfo.dataset.originalSection =
                this.productElement.dataset.originalSection;
              insertedProductInfo.dataset.section = this.quickaddSectionId;
              console.log("[QuickAdd] Updated inserted product-info:", {
                originalSection: insertedProductInfo.dataset.originalSection,
                section: insertedProductInfo.dataset.section,
              });
            } else {
              // Якщо product-info не знайдено, створюємо обгортку
              const wrapper = document.createElement("product-info");
              wrapper.dataset.originalSection =
                this.productElement.dataset.originalSection;
              wrapper.dataset.section = this.quickaddSectionId;
              wrapper.innerHTML = this.modalContent.innerHTML;
              this.modalContent.innerHTML = "";
              this.modalContent.appendChild(wrapper);
              console.log("[QuickAdd] Created wrapper product-info");
            }

            // Також встановлюємо data-section на ProductInfo section для variant-selects
            const productInfoSection = this.modalContent.querySelector(
              '[id^="ProductInfo-"]'
            );
            if (productInfoSection) {
              productInfoSection.dataset.section = this.quickaddSectionId;
              console.log(
                "[QuickAdd] Updated ProductInfo section data-section:",
                this.quickaddSectionId
              );
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            this.updateImageFromCard();
            super.show(opener);
            this.scrollToFeaturedMedia(featuredMediaId);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantSelector = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (variantSelector) {
          variantSelector.setAttribute("data-update-url", "false");
        }
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        const quickaddSectionId = `quickadd-${sectionId}`;
        console.log(
          "[QuickAdd] preventDuplicatedIDs - Original sectionId:",
          sectionId
        );
        console.log(
          "[QuickAdd] preventDuplicatedIDs - New sectionId:",
          quickaddSectionId
        );

        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            quickaddSectionId
          );
        this.productElement.dataset.originalSection = sectionId;
        this.productElement.dataset.section = quickaddSectionId;

        const variantSelectors = this.productElement.querySelectorAll(
          "variant-selects, variant-radios"
        );
        console.log(
          "[QuickAdd] Found variant selectors:",
          variantSelectors.length
        );

        variantSelectors.forEach((variantSelect) => {
          variantSelect.dataset.originalSection = sectionId;
          variantSelect.dataset.section = quickaddSectionId;
          console.log("[QuickAdd] Updated variant-select:", {
            originalSection: variantSelect.dataset.originalSection,
            section: variantSelect.dataset.section,
          });
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        if (!product) return;

        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }

      updateImageFromCard() {
        if (!this.cardImageSrc) {
          console.log("[QuickAdd] No cardImageSrc to update");
          return;
        }

        setTimeout(() => {
          const mediaGallery = this.modalContent.querySelector("media-gallery");
          if (!mediaGallery) {
            console.log(
              "[QuickAdd] Media gallery not found in updateImageFromCard"
            );
            return;
          }

          // Знаходимо перше зображення в галереї
          const firstMediaItem = mediaGallery.querySelector("[data-media-id]");
          if (!firstMediaItem) {
            console.log("[QuickAdd] No media items found in gallery");
            return;
          }

          const firstImage = firstMediaItem.querySelector("img");
          if (firstImage && this.cardImageSrc) {
            console.log(
              "[QuickAdd] Updating first image from card:",
              this.cardImageSrc
            );

            // Знаходимо лоадер
            const loadingSpinner =
              firstMediaItem.querySelector(".loading__spinner");

            // Додаємо обробник події load для приховування лоадера після завантаження
            const hideLoader = () => {
              if (loadingSpinner) {
                loadingSpinner.classList.add("hidden");
              }
              firstImage.removeEventListener("load", hideLoader);
              firstImage.removeEventListener("error", hideLoader);
            };

            // Додаємо обробники перед зміною src
            firstImage.addEventListener("load", hideLoader);
            firstImage.addEventListener("error", hideLoader);

            // Змінюємо src
            firstImage.src = this.cardImageSrc;
            if (this.cardImageSrcset) {
              firstImage.srcset = this.cardImageSrcset;
            }

            // Якщо зображення вже завантажене (з кешу)
            if (firstImage.complete && firstImage.naturalHeight !== 0) {
              hideLoader();
            }
            // Прибираємо display:none якщо є
            firstMediaItem.style.display = "";
            firstMediaItem.style.visibility = "";
            firstMediaItem.classList.remove("hidden");
            firstMediaItem.classList.add("is-active");

            // Також перевіряємо чи є приховані елементи всередині
            const hiddenElements = firstMediaItem.querySelectorAll(
              '.hidden, [style*="display: none"], [style*="display:none"]'
            );
            hiddenElements.forEach((el) => {
              // Не приховуємо лоадер тут, бо він має бути прихований після завантаження
              if (!el.classList.contains("loading__spinner")) {
                el.classList.remove("hidden");
                el.style.display = "";
                el.style.visibility = "";
              }
            });

            console.log("[QuickAdd] Image updated, mediaItem:", {
              display: firstMediaItem.style.display,
              classes: firstMediaItem.className,
              visible: firstMediaItem.offsetParent !== null,
              imageSrc: firstImage.src,
            });

            // Забезпечуємо видимість після оновлення зображення
            let isUpdatingImage = false;
            const ensureImageVisibility = () => {
              if (isUpdatingImage) return;

              const computedStyle = window.getComputedStyle(firstMediaItem);
              const isHidden =
                computedStyle.display === "none" ||
                computedStyle.visibility === "hidden" ||
                firstMediaItem.offsetParent === null ||
                firstMediaItem.classList.contains("hidden");

              if (isHidden) {
                console.log(
                  "[QuickAdd] Forcing visibility in updateImageFromCard"
                );
                isUpdatingImage = true;

                firstMediaItem.style.display = "";
                firstMediaItem.style.visibility = "visible";
                firstMediaItem.classList.remove("hidden");
                firstMediaItem.classList.add("is-active");
                // Перевіряємо батьківські елементи
                let parent = firstMediaItem.parentElement;
                while (parent && parent !== mediaGallery) {
                  const parentStyle = window.getComputedStyle(parent);
                  if (parentStyle.display === "none") {
                    parent.style.display = "";
                  }
                  parent = parent.parentElement;
                }

                setTimeout(() => {
                  isUpdatingImage = false;
                }, 50);
              }
            };

            setTimeout(ensureImageVisibility, 150);
            setTimeout(ensureImageVisibility, 400);
          } else {
            console.log(
              "[QuickAdd] No image found in firstMediaItem or no cardImageSrc"
            );
          }
        }, 100);
      }

      scrollToFeaturedMedia(featuredMediaId) {
        console.log(
          "[QuickAdd] scrollToFeaturedMedia called with featuredMediaId:",
          featuredMediaId
        );
        if (!featuredMediaId) {
          console.log("[QuickAdd] No featuredMediaId provided");
          return;
        }

        setTimeout(() => {
          const mediaGallery = this.modalContent.querySelector("media-gallery");
          console.log("[QuickAdd] Media gallery found:", !!mediaGallery);

          if (!mediaGallery) {
            console.log("[QuickAdd] Media gallery not found in modal content");
            return;
          }

          // Використовуємо збережений sectionId або шукаємо в DOM
          let sectionId = this.quickaddSectionId;
          if (!sectionId) {
            const productInfo = this.modalContent.querySelector("product-info");
            sectionId = productInfo?.dataset?.section;
          }

          console.log("[QuickAdd] Using sectionId:", sectionId);

          if (!sectionId) {
            console.log("[QuickAdd] No sectionId found");
            return;
          }

          const mediaId = `${sectionId}-${featuredMediaId}`;
          console.log("[QuickAdd] Looking for media with ID:", mediaId);

          const allMediaItems =
            this.modalContent.querySelectorAll("[data-media-id]");
          console.log(
            "[QuickAdd] All media items found:",
            allMediaItems.length
          );
          allMediaItems.forEach((item, index) => {
            console.log(
              `[QuickAdd] Media item ${index}:`,
              item.dataset.mediaId
            );
          });

          // Спочатку пробуємо знайти з повним ID
          let mediaItem = this.modalContent.querySelector(
            `[data-media-id="${mediaId}"]`
          );

          // Якщо не знайдено, пробуємо знайти тільки по featuredMediaId
          if (!mediaItem) {
            console.log(
              "[QuickAdd] Media item not found with full ID, trying featuredMediaId only"
            );
            mediaItem = this.modalContent.querySelector(
              `[data-media-id="${featuredMediaId}"]`
            );
          }

          if (mediaGallery.setActiveMedia && mediaItem) {
            console.log(
              "[QuickAdd] Using setActiveMedia method with mediaId:",
              mediaItem.dataset.mediaId
            );
            // Прибираємо display:none та всі приховані класи
            mediaItem.style.display = "";
            mediaItem.style.visibility = "";
            mediaItem.classList.remove("hidden");
            mediaItem.classList.add("is-active");

            // Знаходимо та приховуємо лоадер
            const loadingSpinner = mediaItem.querySelector(".loading__spinner");
            const mediaImage = mediaItem.querySelector("img");
            if (loadingSpinner && mediaImage) {
              // Якщо зображення вже завантажене
              if (mediaImage.complete && mediaImage.naturalHeight !== 0) {
                loadingSpinner.classList.add("hidden");
              } else {
                // Додаємо обробник події load
                const hideLoader = () => {
                  loadingSpinner.classList.add("hidden");
                  mediaImage.removeEventListener("load", hideLoader);
                  mediaImage.removeEventListener("error", hideLoader);
                };
                mediaImage.addEventListener("load", hideLoader);
                mediaImage.addEventListener("error", hideLoader);
              }
            }

            // Перевіряємо всі приховані елементи всередині
            const hiddenElements = mediaItem.querySelectorAll(
              '.hidden, [style*="display: none"], [style*="display:none"]'
            );
            hiddenElements.forEach((el) => {
              // Не приховуємо лоадер тут, бо він має бути прихований після завантаження
              if (!el.classList.contains("loading__spinner")) {
                el.classList.remove("hidden");
                el.style.display = "";
                el.style.visibility = "";
              }
            });

            console.log("[QuickAdd] Media item before setActiveMedia:", {
              display: mediaItem.style.display,
              classes: mediaItem.className,
              visible: mediaItem.offsetParent !== null,
            });

            mediaGallery.setActiveMedia(mediaItem.dataset.mediaId, false);

            // Після setActiveMedia перевіряємо знову та форсуємо видимість
            let isUpdating = false; // Прапорець для запобігання рекурсії
            const ensureVisibility = () => {
              if (isUpdating) return; // Запобігаємо рекурсії

              const computedStyle = window.getComputedStyle(mediaItem);
              const isHidden =
                computedStyle.display === "none" ||
                computedStyle.visibility === "hidden" ||
                mediaItem.offsetParent === null ||
                mediaItem.classList.contains("hidden");

              console.log("[QuickAdd] Media item visibility check:", {
                display: computedStyle.display,
                visibility: computedStyle.visibility,
                offsetParent: mediaItem.offsetParent !== null,
                hasHiddenClass: mediaItem.classList.contains("hidden"),
                isHidden: isHidden,
              });

              if (isHidden) {
                console.log("[QuickAdd] Forcing visibility");
                isUpdating = true; // Встановлюємо прапорець перед змінами

                mediaItem.style.display = "";
                mediaItem.style.visibility = "visible";
                mediaItem.classList.remove("hidden");
                // Також перевіряємо батьківські елементи
                let parent = mediaItem.parentElement;
                while (parent && parent !== mediaGallery) {
                  const parentStyle = window.getComputedStyle(parent);
                  if (parentStyle.display === "none") {
                    parent.style.display = "";
                  }
                  parent = parent.parentElement;
                }

                // Скидаємо прапорець після невеликої затримки
                setTimeout(() => {
                  isUpdating = false;
                }, 50);
              }
            };

            // Перевіряємо кілька разів з різними затримками
            setTimeout(ensureVisibility, 100);
            setTimeout(ensureVisibility, 300);
            setTimeout(ensureVisibility, 500);
            setTimeout(ensureVisibility, 1000);

            // Також додаємо MutationObserver для відстеження змін
            const observer = new MutationObserver((mutations) => {
              if (isUpdating) return; // Пропускаємо, якщо ми самі змінюємо

              mutations.forEach((mutation) => {
                if (
                  mutation.type === "attributes" &&
                  (mutation.attributeName === "style" ||
                    mutation.attributeName === "class")
                ) {
                  // Перевіряємо, чи зміна не від нас самих
                  const target = mutation.target;
                  const computedStyle = window.getComputedStyle(target);
                  if (
                    computedStyle.display === "none" ||
                    computedStyle.visibility === "hidden" ||
                    target.classList.contains("hidden")
                  ) {
                    ensureVisibility();
                  }
                }
              });
            });

            observer.observe(mediaItem, {
              attributes: true,
              attributeFilter: ["style", "class"],
            });

            // Зупиняємо observer через 3 секунди
            setTimeout(() => observer.disconnect(), 3000);
          } else if (mediaItem) {
            console.log(
              "[QuickAdd] setActiveMedia not available, using fallback"
            );
            console.log("[QuickAdd] Media item found:", !!mediaItem);
            // Прибираємо display:none
            mediaItem.style.display = "";
            mediaItem.style.visibility = "";
            mediaItem.classList.remove("hidden");
            mediaItem.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
            mediaItem.classList.add("is-active");
            console.log(
              "[QuickAdd] Scrolled to media item and added is-active class"
            );
          } else {
            console.log("[QuickAdd] Media item not found with ID:", mediaId);
          }
        }, 300);
      }
    }
  );
}
